module.exports = __webpack_public_path__ + "media/images/home/heading-3e113dfd86f30147e4ba00f0d650b6fd.jpg";